const SITE_URL = "https://premierelens.com";

export const STATIC_PAGE_SEO = {
  about: {
    title: "About | PremiereLens",
    description:
      "Learn how PremiereLens lists scripted TV premieres and builds reasoned shows-like recommendations by mood.",
    pathname: "/about",
  },
  privacy: {
    title: "Privacy Policy | PremiereLens",
    description:
      "Privacy policy for PremiereLens, including analytics, local storage, and future advertising practices.",
    pathname: "/privacy",
  },
  faq: {
    title: "FAQ | PremiereLens",
    description:
      "FAQ about how PremiereLens chooses shows, shows-like pages, archive search, refresh cadence, privacy, archive months, and RSS feeds.",
    pathname: "/faq",
  },
};

export function buildStaticPageSeoMeta(pageKey) {
  const config = STATIC_PAGE_SEO[pageKey];
  if (!config) {
    return null;
  }

  return {
    ...config,
    canonicalUrl: `${SITE_URL}${config.pathname}`,
    ogUrl: `${SITE_URL}${config.pathname}`,
    image: `${SITE_URL}/og-image.jpg`,
    robots: "index,follow",
    ogType: "website",
  };
}
